import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Link } from 'react-router';
import { hideModal } from '../../../actions/ModalActions';
import importImages from '../../../util/webpack';

const modalImages = importImages(require.context('../../../assets/images/doodles/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

const PublishPageErrorModal = (props) => {
  const { heading, body, button, closeModal } = props;

  return (
    <div>
      <div id="publish-page-error-modal" className="publish-share-modal text-center">
        <div className="modal-header">
          <img src={modalImages('namecardNoName')} srcSet={modalImages('namecardNoName')} alt="namecard doodle" />
          <h3>{heading}</h3>
        </div>
        <div className="modal-body">
          <p className="body-text">{body}</p>
          <div className="actions">
            {button ? (
              <div>
                <button onClick={() => { button.action(); closeModal(); }} className="btn btn-primary btn-left">{button.text}</button>
                <div onClick={closeModal} className="btn btn-secondary btn-right">Go Back</div>
              </div>
            ) : (
              <div>
                <div onClick={closeModal} className="btn btn-primary">Go Back</div>
              </div>
            )}
          </div>
          <p className="footer-text">
            Not sure how online RSVP works? <a className="text-button" href="https://help.zola.com/hc/en-us/articles/115002251631-How-do-I-set-up-online-RSVPs-" target="_blank" rel="noopener noreferrer">Learn More &rsaquo;</a>
          </p>
        </div>
      </div>
    </div>
  );
};

PublishPageErrorModal.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
  button: PropTypes.shape({
    text: PropTypes.string,
    action: PropTypes.func,
  }),
  closeModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  slug: state.wedding.wedding.slug
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal())
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishPageErrorModal);



// WEBPACK FOOTER //
// ./src/components/manage/website/PublishPageErrorModal.jsx